// extracted by mini-css-extract-plugin
export default {"detail__pages":"Detail_detail__pages__BYgAv","active":"Detail_active__UtpUb"};